(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/directives/interaction/scCommentsList/template', '<div></div>\n' + '');
}]);
})();